// navigation-marquee/client.js
import { EventPubSub } from '../element/public/src/utils/pubSub.js';
import { CLICK, SCROLL } from '../element/shared/enums/events.js';
import { height } from '../element/shared/utils/dont-need-lodash.js';

function isElementInView(element, fullyInView, offset) {
  if (!offset) {
    offset = 0;
  }
  var pageTop = window.pageYOffset;
  var pageBottom = pageTop + Math.max(document.documentElement.clientHeight || 0, innerHeight || 0);
  var elementTop = element.getBoundingClientRect().top;
  var elementBottom = elementTop + height(element) + offset;

  if (fullyInView === true) {
    return ((pageTop < elementTop) && (pageBottom > elementBottom));
  } else {
    return ((elementTop <= pageBottom) && (elementBottom >= pageTop));
  }
}

export default function () {
  // Handle clicks on the UI.
  const $marquee = document.querySelector('.navigation-marquee');
  if (!$marquee) return;

  EventPubSub.subscribe(CLICK, (e) => {
    // Protect 'accept cookie' click event to bubble and trigger this.
    // See more detail on event-handler.js
    if (e.currentTarget.id === 'onetrust-consent-sdk') {
      return;
    }

    const {event, $target} = e;
    const $button = $target.closest('button');
    if ($button) {
      Array.prototype.forEach.call($marquee.querySelectorAll('[data-class]'), (child) => {
        $marquee.classList.remove(child.dataset['class']);
      });

      const clss = $button.dataset['class'];
      $marquee.classList.add(clss);
    }
  });

  // Handle scroll on the UI for homepage.
  const captions = $marquee.querySelectorAll('.caption');
  EventPubSub.subscribe(SCROLL, () => {
    let visible = false;
    Array.prototype.forEach.call(captions, (c) => {
      if (isElementInView(c, false, -35)) {
        visible = true;
      }
    });
    if (visible) {
      $marquee.classList.remove('scrolled');
    }
    else {
      $marquee.classList.add('scrolled');
    }
  });
}